export const mainForm = {
    actions: {
        setFilesInForm({ state }, payload) {
            let component = state;
            component = payload.component;
            let form = payload.form;
            if (component && component.$refs) {
                Object.entries(component.$refs).map(([key, field]) => {
                    let cleanFiles = [];
                    let files = field.dropzone.files;
                    for (var i = 0; i < files.length; i++) {
                        var file = files[i];
                        delete file.dataURL;
                        delete file.previewTemplate;
                        delete file.previewElement;

                        cleanFiles.push(file);
                    }
                    form[key] = cleanFiles;
                });
            }
        },
        joinFilesToControlForm({ getters }, payload) {
            let component = payload.component;
            let form = payload.form;
            let controlId = payload.controlId;
            if (component && component.$refs) {
                Object.entries(component.$refs).map(([fieldName, field]) => {
                    let files = form[fieldName];
                    if (files != null) {
                        Object.entries(files).map(([key, file]) => {
                            var url = getters.getLinkPreviewFileControl({ controlId: controlId, fileId: file.id, key: key });
                            let mockFile = {
                                name: file.originalFileName,
                                size: file.size,
                                mimeType: file.mimeType,
                                id: file.id,
                            };
                            var type = file.mimeType.split('/');
                            var fileUrl = `${url}?type=.${type[1]}`;

                            field.manuallyAddFile(mockFile, fileUrl);
                        });
                    }
                });
            }
        },
        joinFilesToPropertyForm({ getters }, payload) {
            let component = payload.component;
            let attachement = payload.attachement;
            if (component && component.$refs) {
                Object.entries(component.$refs).map(([key, field]) => {
                    if (attachement) {
                        let files = attachement[key];
                        if (files != null) {
                            Object.entries(files).map(([key, file]) => {
                                let mockFile = {
                                    name: file.originalFileName,
                                    size: file.size,
                                    mimeType: file.mimeType,
                                    id: file.id,
                                };

                                var url = getters.getPreviewFileProperty({ fileId: file.id, key: key });
                                var type = file.mimeType.split('/');
                                var fileUrl = `${url}?type=.${type[1]}`;
                                field.manuallyAddFile(mockFile, fileUrl);
                            });
                        }
                    }
                });
            }
        },
    },
};
